import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from 'beam/dist/Typography'
import { CircularProgress } from 'beam/dist/Progress'
import withStyles from 'beam/dist/styles/index'
import { withTranslation } from 'react-i18next'

import AudioEnergy from './AudioEnergy'

const styles = {
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
}

class AudioContent extends Component {
  static displayName = 'AudioContent'

  static propTypes = {
    classes: PropTypes.object.isRequired,
    contactId: PropTypes.number.isRequired,
    callDurationMs: PropTypes.number.isRequired,
    audioDurationMs: PropTypes.number.isRequired,
    audioOffsetMs: PropTypes.number.isRequired,
    storageFileOffsetMs: PropTypes.number.isRequired,
    isRootRecording: PropTypes.bool,
    setTime: PropTypes.func,
    currentTime: PropTypes.number,
    evalId: PropTypes.number,
    events: PropTypes.array,
    energy: PropTypes.object,
    comments: PropTypes.array,
    speechHits: PropTypes.array,
    selectedEventType: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    energyError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onContactUpdate: PropTypes.func.isRequired,
    onEvalUpdate: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    showSpeechHits: PropTypes.bool,
    zoomed: PropTypes.bool,
    isAudioDelayed: PropTypes.bool,
  }

  componentDidMount() {
    //Eval and contact IDs don't change on mount
    this.refreshComments()
    this.refreshEnergy()
  }

  componentDidUpdate(prevProps) {
    const {
      contactId,
      evalId,
      audioDurationMs,
      storageFileOffsetMs,
      isRootRecording,
      zoomed,
      isAudioDelayed = false,
    } = this.props
    const contactIdChanged = prevProps.contactId !== contactId
    const evalIdChanged = prevProps.evalId !== evalId
    const audioDurationMsChanged = prevProps.audioDurationMs !== audioDurationMs
    const storageFileOffsetMsChanged = prevProps.storageFileOffsetMs !== storageFileOffsetMs
    const isRootRecordingChanged = prevProps.isRootRecording !== isRootRecording
    const isZoomedChanged = prevProps.zoomed !== zoomed

    if (
      !isAudioDelayed &&
      (contactIdChanged ||
        audioDurationMsChanged ||
        storageFileOffsetMsChanged ||
        isRootRecordingChanged ||
        isZoomedChanged)
    ) {
      this.refreshEnergy()
    }
    if (contactIdChanged || evalIdChanged) {
      this.refreshComments()
    }
  }

  refreshEnergy(forceZoom) {
    const { contactId, audioDurationMs, storageFileOffsetMs, isRootRecording, onContactUpdate, zoomed } = this.props

    onContactUpdate(
      contactId,
      audioDurationMs,
      storageFileOffsetMs,
      typeof forceZoom === 'boolean' ? forceZoom : zoomed,
      isRootRecording,
    )
  }

  refreshComments() {
    const { contactId, evalId, onEvalUpdate } = this.props

    onEvalUpdate(contactId, evalId)
  }

  renderLoading() {
    const { classes } = this.props
    return (
      <div className={classes.rootNoData}>
        <CircularProgress />
      </div>
    )
  }

  renderAudioEnergyError() {
    const { classes, t } = this.props
    return (
      <div className={classes.rootNoData}>
        <Typography color="secondary" align="center">
          {t('error')}
        </Typography>
        <Typography color="secondary" align="center">
          {t('audioEnergyError')}
        </Typography>
      </div>
    )
  }

  renderData() {
    //This filters out `classes` and `t` so that they are not passed to AudioEnergy
    // eslint-disable-next-line no-unused-vars -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
    const { classes, t, ...energyProps } = this.props

    return <AudioEnergy {...energyProps} />
  }

  render() {
    const { loading, energyError } = this.props

    return (
      <Fragment>
        {loading && this.renderLoading()}
        {!loading && energyError && this.renderAudioEnergyError()}
        {!loading && !energyError && this.renderData()}
      </Fragment>
    )
  }
}

export { AudioContent as UnstyledAudioContent }

export default withTranslation()(withStyles(styles)(AudioContent))
